import { getToken } from "../cookie/authCookie";
import axiosInstance from "./config/axiosConfigs";

export const CoachAPI = {
  getAllPlatformProducts: async function () {
    const response = await axiosInstance.request({
      url: `/platform/products/coach`,
      method: "GET",
      withCredentials: true,
      // timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
 
  fetchAllOrgs: async function (clubName) {
    const response = await axiosInstance.request({
      url: `/register/club/all`,
      method: "POST",
      data: clubName,
      timeout: 8000,
    });
    return response.data;
  },
  fetchAllScheduleHistory: async function (clubId, pageSize, pageNumber, searchKey, filterData) {
    const response = await axiosInstance.request({
      url: `/coach-scheduler/history/${clubId}?pageSize=${pageSize}&pageNumber=${pageNumber}&searchKey=${searchKey}`,
      method: "POST",
      data: {},
      timeout: 8000,
      data: filterData,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  fetchAllScheduleHistoryByUser: async function (clubId, userId, pageSize, pageNumber, searchKey, filterData) {
    const response = await axiosInstance.request({
      url: `/coach-scheduler/history/${clubId}/user/${userId}?pageSize=${pageSize}&pageNumber=${pageNumber}&searchKey=${searchKey}`,
      method: "POST",
      data: {},
      timeout: 8000,
      data: filterData,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  updateAccountSetup: async function (stepperDetails) {
    const response = await axiosInstance.request({
      url: `/account/coach/setup/steps`,
      method: "POST",
      timeout: 5000,
      data: stepperDetails,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  updateAccountSetupPlanInfo: async function (stepperDetails) {
    const response = await axiosInstance.request({
      url: `/account/coach/setup/plan`,
      method: "POST",
      timeout: 5000,
      data: stepperDetails,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  postAddChild: async function (reqChildData, image) {
    let formdata=new FormData();
    formdata.append("image",image);
    formdata.append("childData", JSON.stringify(reqChildData));
    const response = await axiosInstance.request({
      url: `/child/add`,
      method: "POST",
      timeout: 5000,
      data: formdata,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  postCreateTeam: async function (teamData,image) {
    let formData = new FormData();
    formData.append("image", image);
    formData.append("teamData", JSON.stringify(teamData));
    const response = await axiosInstance.request({
      url: `/team/create`,
      method: "POST",
      data: formData,
      // timeout: 2000,
      headers: {
        Authorization: `Bearer ${getToken()}`
      },
    });
    return response.data;
  },
  postAddPLayerToTeam: async function (playerData) {
    const response = await axiosInstance.request({
      url: `/team/add`,
      method: "POST",
      data: playerData,
      // timeout: 2000,
      headers: {
        Authorization: `Bearer ${getToken()}`
      },
    });
    return response.data;
  },
  putUpdateChild: async function (reqChildData,image) {
    let formdata = new FormData();
    formdata.append("image", image);
    formdata.append("childData", JSON.stringify(reqChildData));
    const response = await axiosInstance.request({
      url: `/child/update`,
      method: "PUT",
      timeout: 5000,
      data: formdata,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  putUpdateTeam: async function (reqTeamData,image) {
    let formdata = new FormData();
    formdata.append("image", image);
    formdata.append("teamData", JSON.stringify(reqTeamData));
    const response = await axiosInstance.request({
      url: `/team/update`,
      method: "PUT",
      timeout: 5000,
      data: formdata,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  deleteChild: async function (guardianId,childId) {
    const response = await axiosInstance.request({
      url: `/child/remove/${childId}/by/${guardianId}`,
      method: "DELETE",
      timeout: 5000,
      data: {},
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  deletePlayerFromTeam: async function (reqData) {
    const response = await axiosInstance.request({
      url: `/team/remove`,
      method: "DELETE",
      timeout: 5000,
      data: reqData,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  findAllGuardian: async function (childId) {
    const response = await axiosInstance.request({
      url: `/child/guardian/${childId}`,
      method: "GET",
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  findAllChildren: async function (guardianId) {
    const response = await axiosInstance.request({
      url: `/child/${guardianId}`,
      method: "GET",
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  findChildrenById: async function (guardianId,childId) {
    const response = await axiosInstance.request({
      url: `/child/${childId}/guardian/${guardianId}`,
      method: "GET",
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  findAllTeamPlayer: async function (teamId) {
    const response = await axiosInstance.request({
      url: `/team/player/${teamId}`,
      method: "GET",
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  findAllTeamPlayerForCoach: async function (clubId,userId) {
    const response = await axiosInstance.request({
      url: `/team/player/coach/${clubId}/${userId}`,
      method: "GET",
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  findAllClubPlayer: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/team/club/player/${clubId}`,
      method: "GET",
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  findAllTeamByClubId: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/team/${clubId}`,
      method: "GET",
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  findAllTeamByCoach: async function (clubId, coachId) {
    const response = await axiosInstance.request({
      url: `/team/${clubId}/coach/${coachId}`,
      method: "GET",
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  findAllCoachOrg: async function (coachId) {
    const response = await axiosInstance.request({
      url: `/club/coach-org/${coachId}`,
      method: "GET",
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
}